import { Notification, User } from '../types';
import api from './config';

const NOTIFICATION_API_URL = `${process.env.REACT_APP_SERVER_URL}/notification`;

/**
 * Restructures the users array to remove unnecessary fields.
 * @param users The array of users to restructure.
 * @returns The restructured array of users.
 */
const restructureUsers = (users: User[]) =>
  users.map(user => ({
    ...user,
    notifications: [],
    questions: [],
    answers: [],
    comments: [],
    followers: [],
    following: [],
  }));

/**
 * Adds a notification to the database.
 * @param notification The notification to add.
 * @returns The added notification.
 */
const addNotification = async (notification: Notification): Promise<Notification> => {
  const restructuredSenderFollowers = restructureUsers(notification.sender.followers);
  const restructuredSenderFollowing = restructureUsers(notification.sender.following);
  const restructuredReceiverFollowers = restructureUsers(notification.receiver.followers);
  const restructuredReceiverFollowing = restructureUsers(notification.receiver.following);
  const restructuredNotification = {
    message: notification.message,
    sender: {
      ...notification.sender,
      followers: restructuredSenderFollowers,
      following: restructuredSenderFollowing,
      notifications: [],
      questions: [],
      answers: [],
      comments: [],
    },
    receiver: {
      ...notification.receiver,
      followers: restructuredReceiverFollowers,
      following: restructuredReceiverFollowing,
      notifications: [],
      questions: [],
      answers: [],
      comments: [],
    },
    notificationType: notification.notificationType,
    notificationDateTime: notification.notificationDateTime,
    path: notification.path,
  };

  const res = await api.post(`${NOTIFICATION_API_URL}/addNotification`, {
    notification: restructuredNotification,
  });

  if (res.status !== 200) {
    throw new Error('Error adding notification', res.data);
  }
  return res.data;
};

export default addNotification;
